import { useState } from "react";
import "./App.css";
import HomePage from "./pages/HomePage";
import Navbarr from "./components/Navbarr";
import { Routes, Route, BrowserRouter as Router, Navigate } from "react-router-dom";
import ContactPage from "./pages/ContactPage";
import WorkPage from "./pages/WorkPage";
import Footer from "./components/Footer";
// import ClientWork from "./components/ClientWork";
// import ClientWorkPage from "./pages/ClientWorkPage";
import AboutPage from "./pages/AboutPage";
import CertificatesPage from "./pages/CertificatesPage";
import ScrollToTop from "./components/ScrollToTop";
function App() {
  return (
    <Router>
    {/* <NavSocialLink/> */}
      <Navbarr />
      <ScrollToTop/>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/certificates" element={<CertificatesPage/>} /> 
        <Route path="/work" element={<WorkPage />} />
        <Route path="/aboutme" element={<AboutPage/>} />
        <Route path="/contact" element={<ContactPage />} />

        {/* 
        <Route path="/client/:id" element={<ClientWorkPage/>} />
        <Route path="/aboutme" element={<AboutPage/>} />
        <Route path="/certificates" element={<CertificatesPage/>} /> */}
    
         </Routes>
         <Footer/>
    </Router>
  );
}
export default App;
